import { createReducer } from "redux-starter-kit";
import { appSetIssueAction } from "../actions/appIssues";

const INIT_STATE = {};

const appIssues = createReducer(INIT_STATE, {
  [appSetIssueAction]: (state, action) => {
    state[action.payload.issue.id] = action.payload.issue;
  }
});

export default appIssues;
